import { parseMoney, ZERO, type Centavos } from '@abastece/shared';

/**
 * El envío: what the customer pays for having their goods brought, typed above the total of the
 * till and of a new order (the owner, 2026-10-12: «the delivery cost line shouldn't be GATED by
 * hitting the "charge" button it should be like an optional field above total»). It was asked in
 * «Cobrar», and only for an order.
 */

/** What is typed, in centavos: nothing typed is none; null for what is not an amount, or below zero. */
export function leerEnvio(texto: string): Centavos | null {
  if (!texto.trim()) return ZERO;
  const monto = parseMoney(texto);
  return monto === null || monto < 0 ? null : monto;
}

/** An order's, as the till's field starts out holding it: empty for none, where the field says 0.00. */
export const textoDeEnvio = (envio: Centavos | undefined): string => (envio && envio > 0 ? (envio / 100).toFixed(2) : '');
